import React, { useEffect, useState } from 'react';
import Table from '../../componenets/Table';
import { FaPlus } from "react-icons/fa";
import AddGroupModal from './AddGroupModal';
import { MdEdit, MdDelete } from "react-icons/md";
import PageLoader from '../../componenets/PageLoader';
import ConfirmModal from '../../componenets/ConfirmModal';
import { getAllBrands, deleteBrandsDetail } from '../../services/data/brands';
import { toast } from 'react-toastify';
import '../../style/style.css';
import "bootstrap/dist/css/bootstrap.min.css";

const Group = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false) 
  const [deleteshow, setDeleteshow]  = useState(false)
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [groupId, setGroupId] = useState();
  const [detail, setDetail] = useState();
  
  const deleteShowModal =(id)=>{
    setGroupId(id)
    setDeleteshow(true)
  }
    
  const addShowGroup = ()=>{
    setAddShow(true)
    setDetail(null)
    setGroupId(null)
  }

  const editShowGroup =(id, data)=>{
    setGroupId(id)
    setDetail(data)
    setAddShow(true)
  }
  
  const handleClose = ()=>{
    setAddShow(false)
    setEditShow(false)
    setDeleteshow(false)
  }

  const onConfirm = ()=>{
    setDeleteshow(false)
    deleteBrandsDetail(groupId).then((response)=>{
      if(response.data.status === 'success'){
        toast.success(response.data.message)
        fetchUsers()
      }
    })      
  }

  // const data = [
  //   {
  //     id:1,
  //     group: 'Group 1',
  //   },
  //   {
  //     id:2,
  //     group: 'Group 2',
  //   },
  // ];

  const columns = [
    { 
      title: 'SI.NO', 
      field: 'id',    
    },
    { 
      title: 'Brand', 
      field: 'name',      
    },
    { 
      title: 'Action', 
      render : (rowData)=>{
        return(
          <>
            <MdEdit
              onClick={()=>editShowGroup(rowData.id, rowData)}               
              fontSize="20px"
              style={{
                cursor:'pointer'
              }}
            />
            &nbsp; &nbsp;
            <MdDelete 
              onClick={()=>deleteShowModal(rowData.id)} 
              fontSize="20px"
              style={{
                cursor:'pointer'
              }}
            />
          </>
        )
      }      
    },   
  ];
 
  const fetchUsers = async () => {
    setLoading(true)      
    await getAllBrands().then((response)=>{ 
      // console.log(response)         
      if (response.status === 200 || response.data.status === 'success'){        
        if(response.data.data.length > 0){
          setData(response.data.data)
        }else{
          setData([])
        }               
      }else{
        toast.error(response.data.message)        
      }           
    })      
    .catch((err)=>{
      toast.error("Error fetching");      
    })
    .finally(()=>{
      setLoading(false)
    })              
  }

  useEffect(() => {    
    fetchUsers()
  }, []);


  return (
    <div>
      {
        loading ? <PageLoader loading="Loading..." /> : (
          <section className='content'>
            <div className='container-fluid'>
              <div className='row' >
                <div className='card border-0'>
                  <div className='card-body'>
                    <div className='col-12 text-end'>
                      <FaPlus
                        onClick = {()=>addShowGroup()} 
                        fontSize={'20px'}
                        style={{
                          cursor:"pointer"
                        }}
                      />
                    </div>
                    <div className='col-12 mt-4'>
                      <div>       
                        <Table
                          columns={columns}
                          data={data}
                        />
                      </div>
                    </div>
                  </div>
                </div>          
              </div>
            </div>
            {
              addShow &&
              <AddGroupModal 
                show = {addShow}
                handleClose = {handleClose}
                id = {groupId}
                fetchUsers = {fetchUsers}
                detail = {detail}
              /> 
            }    

            { 
              deleteshow &&
              <ConfirmModal
                show={deleteshow}
                handleClose={handleClose}
                onConfirm = {onConfirm}
                content = {'Do you want to Delete ?'}
              />
            }        
          </section>
        )
      }
       
    </div>
   
  )
}

export default Group
